import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';
import Order from './order';
import { UserProfile } from 'app/entities/user-profile/user-profile';
import { Deposit } from 'app/entities/deposit/deposit';
/* jhipster-needle-add-route-import - JHipster will add routes here */

export default () => {
  return (
    <div>
      <ErrorBoundaryRoutes>
        {/* prettier-ignore */}
        {/* <Route path="mail/*" element={<Mail/>}/>*/}
        {/* <Route path="mail-type/*" element={<MailType />} />*/}
        {/* <Route path="mail-group/*" element={<MailGroup />} />*/}
        {/* <Route path="deposit-transaction/*" element={<DepositTransaction/>}/>*/}
        <Route path="order/*" element={<Order />} />
        {/* <Route path="bank/*" element={<Bank />} />*/}
        <Route path="profile/*" element={<UserProfile />} />
        <Route path="deposit/*" element={<Deposit />} />
        {/* jhipster-needle-add-route-path - JHipster will add routes here */}
      </ErrorBoundaryRoutes>
    </div>
  );
};
